export default "__VITE_ASSET__hmyAt_k5__"